const documentsValues = [
    "CO1C",
    "CO1E",
    "CO1T",
    "CO1P",
    "CO1V",
    "CO1W",
];

const documentsTrans = (documentsEntry) => {
    return documentsEntry.map((documentEntry, idx) => ({
        name: documentEntry, 
        value: documentsValues[idx]
    }));
};

export default documentsTrans;